import { APP_LOADED_ERROR, APP_LOADED_PENDING, APP_LOADED_COMPLETED } from '../actions/application';

const initialState = {
    appLoaded: {
        pending: false,
        completed: false,
        error: false,
    },
};

export function reducer(state = initialState, action = {}) {
    switch (action.type) {
        case APP_LOADED_ERROR:
            return {
                ...state,
                appLoaded: {
                    pending: false,
                    completed: false,
                    error: true,
                },
            };
        case APP_LOADED_PENDING:
            return {
                ...state,
                appLoaded: {
                    pending: true,
                    completed: false,
                    error: false,
                },
            };
        case APP_LOADED_COMPLETED:
            return {
                ...state,
                appLoaded: {
                    pending: false,
                    completed: true,
                    error: false,
                },
            };
        default:
            return state;
    }
}
